var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongKuaijie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.5,
    stroke: "#3F465C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.724 8.684l3.33-4.696a.2.2 0 01.363.11L8.5 7h2.434a.2.2 0 01.168.308l-3.068 4.773a.2.2 0 01-.368-.097L7.5 9H4.887a.2.2 0 01-.163-.316z",
    fill: "#3F465C"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjYuNSIgc3Ryb2tlPSIjM0Y0NjVDIi8+CjxwYXRoIGQ9Ik00LjcyMzg1IDguNjg0MzFMOC4wNTQwMiAzLjk4NzkyQzguMTY1MDggMy44MzEyOSA4LjQxMTYgMy45MDU5NiA4LjQxNzA4IDQuMDk3OUw4LjUgN0gxMC45MzM3QzExLjA5MTkgNyAxMS4xODc1IDcuMTc1MDUgMTEuMTAxOSA3LjMwODE1TDguMDMzNyAxMi4wODA5QzcuOTI4ODUgMTIuMjQ0IDcuNjc2NTMgMTIuMTc3NSA3LjY2NTc3IDExLjk4MzlMNy41IDlINC44ODdDNC43MjQ2NCA5IDQuNjI5OTQgOC44MTY3NiA0LjcyMzg1IDguNjg0MzFaIiBmaWxsPSIjM0Y0NjVDIi8+Cjwvc3ZnPgo=";
export { SvgTongyongKuaijie as ReactComponent };